import { render, staticRenderFns } from "./_filter_by_uploaded_from.vue?vue&type=template&id=07061864&scoped=true&"
import script from "./_filter_by_uploaded_from.vue?vue&type=script&lang=js&"
export * from "./_filter_by_uploaded_from.vue?vue&type=script&lang=js&"
import style0 from "./_filter_by_uploaded_from.vue?vue&type=style&index=0&id=07061864&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07061864",
  null
  
)

export default component.exports